import React from 'react';
import haystack from './haystack';
import View from '@loggi/ui/components/view';

export function defaultGetSuggestionValue(suggestion) {
  return (suggestion && suggestion.label) || '';
}

export function defaultRenderSuggestion(suggestion, { value }) {
  const haystackedSuggestion = haystack(
    (suggestion && suggestion.label) || '',
    value
  );

  if (__NATIVE__) {
    return haystackedSuggestion;
  }

  // TODO(@renatoagds) remove this and use native approach
  const props = {
    dangerouslySetInnerHTML: {
      __html: `<span>${haystackedSuggestion}</span>`
    }
  };

  return <View {...props} />;
}
